import React from 'react'
import PropTypes from 'prop-types'

import WishlistLabel from './WishlistLabel'
import CardImage from './CardImage'
import CardTitle from './CardTitle'
import { ProductAvailabilityContainer } from './ProductAvailability'

const ProductCard = ({ sku, imageUrl, name, originalId, vendorId }) => (
  <div className='item card'>
    <div className='bordered radius border-color-ui-3 bg-white'>
      <div className='row mx-0 px-1'>
        <div className='col-12 discount-whishlist'>
          <WishlistLabel sku={sku} />
        </div>
        <CardImage linkTo={`/products/${sku}`} imageUrl={imageUrl} altText={name} />
        <div className='card-internal col-12 pt-md-0 pt-2 mt-2 mt-md-0'>
          <CardTitle linkTo={`/products/${sku}`} title={name} />
          <ProductAvailabilityContainer sku={sku} originalId={originalId} vendorId={vendorId} />
        </div>
      </div>
    </div>
  </div>
)

ProductCard.propTypes = {
  sku: PropTypes.string.isRequired,
  name: PropTypes.string,
  imageUrl: PropTypes.string,
  originalId: PropTypes.string,
  vendorId: PropTypes.string
}

export default ProductCard



// WEBPACK FOOTER //
// ./src/features/Availability/ProductCard/ProductCard.js